import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';

export default function NationalCodeControl(props) {

    const [value, setValue] = useState(props.value);

    function onChange(value) {
        setValue(value);
        if (props.onChange)
            props.onChange(value)
    }

    function onBlur(value) {
        setValue(value);
        if (props.onBlur)
            props.onBlur(value)
    }

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Label>{props.title}<span class="text-danger fw-bold"> {props.required && '*'}</span> </Form.Label>
                <Form.Control
                    type="text"
                    ref={props.inputRef}
                    value={value}
					valid={props.valid}
					required={props.required}
					maxlength={props.maxlength ?props.maxlength:'16'}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={(e) => onBlur(e.target.value)}
                    placeholder={props.placeholder}
                />
            </Form.Group>
        </div>
    )
}